import React from 'react';
import {LauncherComponentBase} from '../../base-components/launcher-component-base';
import {TextValueEditorComponent} from '../text-value-editor/text-value-editor.component';
import {Check} from '@sparkware/app-utils';
import {observer} from 'mobx-react';
import {IConfigFieldDefinition} from '../../../services/configurations-areas/fields-definitions/config-field-definition-base';

export interface NumericValueEditorComponentProps {
    fieldDefinition: IConfigFieldDefinition;
    allowDecimals?: boolean,
    placeholder?: string;
}

@observer
export class NumericValueEditorComponent extends LauncherComponentBase<NumericValueEditorComponentProps> {

    static defaultProps = {
        allowDecimals: true,
        placeholder: 'Default'
    };

    private _validParse = (value: any) => {
        return {
            isValid: true,
            value: value
        };
    };

    private _invalidParse = () => {
        return {
            isValid: false
        };
    };

    private _parseUserInput = (value: string) => {
        if(!value) {
            return this._validParse(value);
        }
        try {
            if(!this.props.allowDecimals && value.indexOf('.') >= 0) {
               return this._invalidParse();
            }
            // eslint-disable-next-line
            let parsedValue = new Number(value);
            if(!Check.isNumber(parsedValue)) {
                return this._invalidParse();
            }
            if(value.endsWith('.')) {
                return this._invalidParse();
            }
            return this._validParse(parsedValue);
        } catch (err) {
            this.services.logger.error(`Invalid numeric value ${value} for field ${this.props.fieldDefinition.configurationKey}`);
            return this._invalidParse();
        }
    };

    render() {
        return (
            <TextValueEditorComponent fieldDefinition={this.props.fieldDefinition}
                                      parseUserInput={this._parseUserInput}
                                      placeholder={this.props.placeholder} />
        );
    }
}